import { render, staticRenderFns } from "./EventsControllers.vue?vue&type=template&id=f73b3940"
import script from "./EventsControllers.vue?vue&type=script&lang=js"
export * from "./EventsControllers.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports